
import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect,useRef } from "react";
import ImageUploading from 'react-images-uploading';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { auth } from "../firebase/firebaseDb.js";
import { ToastContainer, toast } from 'react-toastify';
import Header from "../components/Header";
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { useTranslation } from "react-i18next";

import { 
FacebookAuthProvider,
 GoogleAuthProvider,
 signInWithPopup ,
 signInWithRedirect,
 OAuthProvider,
 sendSignInLinkToEmail,
 createUserWithEmailAndPassword,
 signInWithEmailAndPassword,
 updateProfile,
 sendEmailVerification,
 onAuthStateChanged
 } from "firebase/auth";









export default function CodeCredit() {
	
	 const modalRef = useRef();
	// const [progress, setProgress] = useState(10); // initial 10%
	   const { t } = useTranslation();
	   const [selectedServiceName, setSelectedServiceName] = useState('');
       const [selectedServiceDescription, setSelectedServiceDescription] = useState('');
	   const [serviceMode, setServiceMode] = useState('save');
	   const [oldServiceName, setOldServiceName] = useState('');
	   
	   const [businessName, setBusinessName] = useState('');
	   const [businessType, setBusinessType] = useState('');
	   const [businessAddress, setBusinessAddress] = useState('');
	   const [businessEmail, setBusinessEmail] = useState('');
	   const [businessPhone, setBusinessPhone] = useState('');
	    const [services, setServices] = useState([]);
	   const [images, setImages] = React.useState([]);
  	   
		
	   const [step, setStep] = useState(0);
	   const [inputReply, setInputReply] = useState('');
	    const [showInputReply, setShowInputReply] = useState('flex');
	 const [showSpinner, setShowSpinner] = useState('none');	
	   const [stepInput,setStepInput]=useState('');
	   const maxNumber = 15;
	   const [websiteGeneratorStatus, setWebsiteGeneratorStatus] = useState('');
	  const [remoteImages, setRemoteImages] = useState([]); 
   const [createdWebsiteID, setCreatedWebsiteID] = useState('');	  
	   const [openAIResult, setOpenAIResult]=useState(null);
	   const [urlPath, setUrlPath]=useState('');
	  const [userInfo, setUserInfo]=useState(JSON.parse(localStorage.getItem('user_info'))); 
   const [firebaseUserInfo, setFirebaseUserInfo]=useState(JSON.parse(localStorage.getItem('firebase_user'))); 
    const [websitesList, setWebsitesList]=useState([]);   
    const [websiteLoadState, setWebsiteLoadState]=useState('loaded');
	  
	  
	  
	  
	     const [email, setEmail] = useState(firebaseUserInfo.email);
	    const [fullName, setFullName] = useState(firebaseUserInfo.displayName);
       const [password, setPassword] = useState('');
	     const [oauthProvider, setOauthProvider] = useState(firebaseUserInfo.providerData[0].providerId);
	  
	  const [creditCodeList, setCreditCodeList]=useState([]);
	  
	  
	  
	  
	  
	  
	  
	  
	 const questions = [
    "Let’s get started! What’s the name of your business?",
    "Which type of activity are your business serve?",
    "Where is your business located?",
	"What's your email",
	"What is your phone number",
    "What’s your business products or services?",
	"Choose few images in your library that will be use for your website"
  ];

  const placeholders = [
     "eg ZuriBuild Inc.",
	"eg barbershop",
    "eg Lagos, Nigeria",
    "eg example@email.com",
	"Your phone number",
	"Services / products",
	"Images gallery"
  ];
  
  
  
  
  const WP_API = "http://localhost/zuribuild/panecran/wp-json/wp/v2/pages";
const USERNAME = "root"; // your WP username
const APP_PASSWORD = "sKy6 q263 5Aq7 FVOv R44X P27G"; // your generated Application Password
const token = btoa(`${USERNAME}:${APP_PASSWORD}`);





const config = {
    public_key: 'FLWPUBK-77908cda01ad7bb0c1e7501c581ccfc8-X', // Replace with your Public Key
    tx_ref: Date.now().toString(),
    amount: 2500,
    currency: 'KES',
    payment_options: '*',
    customer: {
      email: 'user@gmail.com',
      phone_number: '070********',
      name: 'John Doe',
    },
    customizations: {
      title: 'My Store',
      description: 'Payment for items in cart',
      logo: 'https://your-brand-logo.com/logo.png',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

const navigate = useNavigate();





  



	 useEffect(() => {
			   if (!localStorage.getItem('user_info')) {
      navigate('/login');
      return;
    }
   console.log(firebaseUserInfo.providerData[0].providerId)
   getAllCreditCode();
 /* setFullName(firebaseUserInfo.displayName)
  setEmail(firebaseUserInfo.email)
  setOauthProvider(firebaseUserInfo.providerData[0].providerId) */
  },[]);



















//function to get all payment history of the logged user----------------------------------------------------------------
const  getAllCreditCode= async () => {
	setWebsiteLoadState('loading');
//setShowSpinner('inline-block')
	  const payload={
		
		 beneficiary_email: firebaseUserInfo.email,
		 
		
	  }
	  
	  
	//  axios.post("http://localhost/zuribuildAPI/get-credit-code.php", payload, {
		
		axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/get-credit-code.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
 // alert(res.data);
  
setCreditCodeList(res.data);
  setWebsiteLoadState("loaded");
	
	 
    })
    .catch((err) => {
		// setShowSpinner('none')
		setWebsiteLoadState("loaded");
      console.error("Error:", err.message);
	   toast.error(err.message, {
      position: 'bottom-right',
    });
    });
};


  
  
   const handleNext = () => {
	   //alert(step)
  /*  if (step < questions.length - 1) {
      setStep(step + 1);
    } */
	
	   if (step < questions.length - 1) {
	if(step==0){
		if(businessName==''){
		alert("this have to be filled")	
		}
		
		else{
		checkBusinessName(businessName)	
		}
	}
	
	
 if(step==1){
	 if(businessType==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }	


 if(step==2){
	 if(businessAddress==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }


 if(step==3){
	 if(businessEmail==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 } 
 
 
 
  if(step==4){
	 if(businessPhone==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }
 
 
   if(step==5){
	
  setStep(step + 1);
		
 }
	   }
	

  };
  
  
  
  
  
  
  //function to check the business name in my database
  const checkBusinessName=async()=>{
	
  }
  
  
  
  
  
  
   const onChangeImage = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  
  
  
  
  
  
  //function to check if the business name already exist in the database
  const checkBusinessNameAvailability=()=>{
	 // alert("we wil check if this business name already exist")
	  
  }
  
  
  
    const handleBack = () => {
		setShowInputReply('none ')		
		setInputReply('')
    if (step > 0) {
      setStep(step - 1);
    }
  };
  
  
  
    const addNewService = () => {

//  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
//  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
  
//  setSelectedServiceName('');
//  setSelectedServiceDescription('');
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */
 const modal = window.bootstrap.Modal.getInstance(modalRef.current);

  if(serviceMode=='save'){
	  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
	   setServiceMode('save');
  }
  
  else if(serviceMode=='edit'){
	//  alert(selectedServiceName)
 setServices((prevServices) =>
      prevServices.map((service) =>
        service.name === oldServiceName
          ? { name: selectedServiceName, description: selectedServiceDescription }
          : service
      )
    );
	  setServiceMode('save');
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
  }
   
   
  };
  
  
  
  
  
  
  
  

  // progress = (currentStep + 1) / totalSteps * 100
  const progress = ((step + 1) / questions.length) * 100;



 // Service functions
  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const addService = () => {
    setServices([...services, { name: "", description: "" }]);
  };
	
	
	

	
	
	
	
	
	// Function to remove an item by id
  const removeService = (name) => {
	  
	//  alert(id)
    setServices((prevServices) =>
      prevServices.filter((service) => service.name !== name)
    );
  };
	
	
	//function to view the service detail
	const viewService = (name,description) => {

 
  setServiceMode('edit');
  setOldServiceName(name);
  setSelectedServiceName(name);
  setSelectedServiceDescription(description);
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.show();
  };
	
	
	
	
	
	//function to close the service modal
	const closeModal = () => {

 
  
  setSelectedServiceName('');
  setSelectedServiceDescription('');
  

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.hide();
  };
	
	
	
//function to replace a service 

const replaceService = (oldName, newService) => {
  setServices((prevServices) =>
    prevServices.map((service) =>
      service.name === oldName ? newService : service
    )
  );
};	
	
	
	
	
	
	
	
//function to normalize busines name with hyphen	
	
function normalizeBusinessName(name) {
  // Split into words, trim spaces, filter out empties
  const words = name.trim().split(/\s+/).filter(Boolean);
  
  // If only one word, return as is, else join with '-'
  return words.length > 1 ? words.join("-") : words[0];
}	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
//function to convert the json generate by openAI to wordpress Gutenbeerg syntax

// Utility: Convert AI JSON → WP Gutenberg blocks
function convertJsonToWpBlocks(pageJson) {
  let content = "";

  pageJson.sections.forEach((section) => {
	 // alert(section.images[0].url)
    content += `<!-- wp:group {"className":"custom-section"} -->
      <div class="wp-block-group custom-section">
        <h2>${section.title}</h2>
        <p>${section.paragraph}</p>
			
        
      </div>
    <!-- /wp:group -->`;
	
	if(section.images && section.images.length > 0){
		section.images.forEach((img) =>{
		content +=` <!-- wp:image {"url":"${img.url}","alt":"${img.alt || section.title}"} -->
		<div class="wp-block-image">
		 <img src="${img.url}"  class="section-image"/>
		 </div>
		 <!-- /wp:image -->
		 `;
		});
	}
	
	
	  
	
	
	
  }); 

  return content;
}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
// rest API to create a new website subdomain on the server hosting


const createNewWebsite=async()=>{
	
}




const saveWebsiteClientInformationToDatabase=async(website_name,wp_url)=>{
	 setShowSpinner('inline-block')
	  const payload={
		 website_name:website_name, 
		 wp_url: wp_url,
		 id:1,
		 created_at: new Date(),
		 expiry_date: new Date(),
	  }
	  axios.post("http://localhost/zuribuildAPI/add-website.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert("Websites added successfully");
  
 // getNewImagesForWebsite();
 createWebsiteStructureViaAI(wp_url);
 deleteSamplePage(wp_url);	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
}





// rest api to delete the sample page that is automatically create when we create a new website

const deleteSamplePage=async(wp_url)=>{
	axios.delete("http://localhost/zuribuild/"+wp_url+"/wp-json/wp/v2/pages/2", {
 headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        }
})
.then(
res => {
	alert("Default page deleted")
})
.catch(err => {
	alert(err)
	console.log(err)
});
	
}


// rest API to generate images that will be use for the website via pexels API

const getNewImagesForWebsite=async()=>{

axios.get('https://api.pexels.com/v1/search', {
    headers: {
      Authorization: 'hlMsBY7tC1kHzAmGK2M4SwixocehvaIwi5oV0joaWe0HhQA5tS3UDzPq',
    },
    params: {
      query: businessType,
      per_page: 15,
    },
  })
  .then((response) => {
    // ✅ Success
    console.log("Photos fetched successfully!");
    const photos = response.data.photos;
	setRemoteImages(response.data.photos);
	console.log(photos)
   /* photos.forEach((photo, i) => {
      console.log(`${i + 1}. ${photo.src.medium}`);
    }); */
  })
  .catch((error) => {
    // ❌ Error
    if (error.response) {
      console.error("API responded with error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
  });
}	
	
	
	
// rest API to save media library to the website to wordpress API
const saveImagesLibray=async()=>{


alert("save images libraries for the current website")
}
















// rest API TO CREATE AND STRUCTURE CONTENT with openAI API
const createWebsiteStructureViaAI=async(wp_url)=>{
//alert("the website json content had been create through openAI")
const OPENAI_API_KEY='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';
try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-5", // lightweight but strong
        messages: [
          {
            role: "system",
            content: "You are an AI that generates structured JSON for professional websites."
          },
          {
            role: "user",
            content: `
Generate a structured JSON for a professional website. 
It must have 4 pages: Home, About, Services, Contact. 
Each page should contain sections with title, paragraph, and images.
If services are provided, make sure to create a detailed Services page.
include navigation menu that will match the number of pages and each menu will 
have the name or title of the pages created.
if images are not provided use a default placeholder images instead from the link
https://placehold.co/widthxheight .

Business Info:
- Name: ${businessName}
- Description: ${businessType}
- Address: ${businessAddress || "Not provided"}
- Email: ${businessEmail || "Not provided"}
- Phone: ${businessPhone || "Not provided"}
- Services: ${JSON.stringify(services || [])}

Use these image URLs where relevant if available:
${images.join("\n")}
          `
          }
        ],
        
      },
      {
        headers: {  
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "Content-Type": "application/json"
        }
      }
    );

    const aiContent = response.data.choices[0].message.content;
	//alert(response.data.choices[0].message.content)
	//alert(urlPath);
	console.log(aiContent);
	//setOpenAIResult(JSON.parse(aiContent))
	var segmentizedAIContent=JSON.parse(aiContent)
	
	setTimeout(function() {
  createPagesForWebsite(wp_url,segmentizedAIContent);
}, 10000);
	
	
  //  return JSON.parse(aiContent); // structured JSON ready to send to WordPress API
  } catch (error) {
    console.error("Error generating site content:", error);
	//createWebsiteStructureViaAI();
    return null;
  }	
	
}







//function to generate pages for the website we just created 


const createPagesForWebsite=async(wp_url,content)=>{
	var createdPageNumber=0;
	var pagesCreated=[];
	
	
	for (let page of content.pages) {
      const content = convertJsonToWpBlocks(page);
  // alert(page.id);
   
     try{
   const response=  await axios.post(
        "http://localhost/"+wp_url+"/wp-json/wp/v2/pages",
        {
          title: page.id,
		 // title: "page"+createdPageNumber+1,
		//  slug: "page"+createdPageNumber+1,
          content: content,
          status: "publish"
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
	  console.log('Page created successfully:', response.data);
	   const pageId = response.data.id;
      const pageTitle = response.data.title.rendered;
      createdPageNumber+=1;
	  
	  
	//  pagesCreated.push([pageTitle,pageId])
   //   console.log(`✅ Page created: ${pageTitle} (ID: ${pageId})`);
	
	 }
	 
	 catch (error) {
		 alert(error)
            console.error('Error creating page:', error.response ? error.response.data : error.message);
            throw error;
			//createPagesForWebsite();
        }
	  
    }



	
}






//function to resend verificstion link----------------------------------------------------------------------------------------------------------------------
  const handleResend = async () => {
	  
	  const actionCodeSettings={
		url: "https//hermanntrucking.ca/login",
        handleCodeInApp: true		
		  
	  }
	  
	  
    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        alert("Verification email resent! Check your inbox.");
      } catch (error) {
        alert(error.message);
      }
    } else {
      alert("No user is logged in.");
    }
  };
  
  
  
  
  
  
  
  
  
  
  
  







// rest API to create pages for the website though the wordpress
const goToWizard=async()=>{
	
	navigate("/")
}



//functiuon to copy the code PIN------------------------------------------------------------------------------------
const copyCode=async(credit_code)=>{
	navigator.clipboard.writeText(credit_code);
	
	  toast.success(t("credit-code.credit_code"), {
      position: 'bottom-right',
    });
	//alert("Gift code copied ");
	
}
	
	
	
	
	
	
	
	
	
	
	
	
	
  return (
  <>
  
  <style>{`

        body {

          margin: 0;

          font-family: Arial, sans-serif;

          background-color: #fff;

          color: #000;

        }



       


        .logo {

          font-weight: bold;

          font-size: 20px;

          color: red;

        }



        .step {

          font-size: 14px;
          font-weight:550;
          color: #555;
         
		  
        }



        /* Progress Bar */

        .progress-bar {

          width: 100vw;

          height: 4px;

          background-color: rgb(228,228,230);

        }
		
		
		
		#progress-indicator {

         // width: 20vw;

          height: 4px;

          background-color: black;
		  transition: width 0.6s ease; 

        }



        /* Body */

        .container {

          display: flex;

          justify-content: center;

          align-items: center;
          width:100%;
          padding: 40px 20px;
         
        }



        .content {

          width: 90vw;
          
        //  background:white;
          

        }



        h2 {

          margin-bottom: 20px;

          font-size: 24px;

          color: #000;

        }



        .input-box {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: 1px solid #ccc;

          padding: 0 15px;

          font-size: 16px;

          margin-bottom: 20px;

          box-sizing: border-box;

        }



        .btn {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: none;

          background-color: purple;

          color: white;

          font-size: 16px;

          cursor: pointer;

          transition: 0.3s;

        }

  .website-block{
  width: 25vw;
	display: flex;
		flex-wrap: wrap;
	height: 200px;
	border-radius: 10px;
	box-shadow: 5px 5px 5px silver;
	
   margin:5px;
   overflow:hidden;
  }
  
  .label-input{
	font-size:14px;
    font-weight:bold;
    color:purple;
  }
  
  

/* Fade effect */
        .fade {
		padding-bottom:70px;
		margin-top:70px;
          opacity: 0;
          transform: translateY(10px);
          animation: fadeIn 0.6s ease forwards;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }



        .btn:hover {

          background-color: #5a0e8f;

        }
   
   .website-btn{
   margin-top:5px;
   margin-left:75px;
   width:55%;
  
   }
   
   .btn-delete{
   background-color:red;
   }
   
   
   
     .website-block-action{
	
	  background: linear-gradient(to bottom, rgba(192,192,192,1), rgba(0,0,0,1));
	 position:absolute;
	border-radius:10px;
	 z-index:1000;
	width:25vw;
	height:200px;
	text-align:justify;
	padding-left:15px;
	}
	
	.title-website{
	
	color:white;
	font-weight:bold;
	margin-top:20px;
	}


        /* Responsive */

     



        @media (max-width: 767px) {

          .content {

            width: 100% !important;

          }
		  
		  		    .website-block{
  width: 90vw !important;
	
  }
  
  .website-block-action{
  width: 90vw !important;
  }
  
  .your-website-title{
  margin-left:-20px;
  
  }
  
  .block-list-container{
  width:95vw !important;
  }

        }

      `}</style>



      {/* Header */}

     <Header/>







      {/* Body */}

      <div className="container">

         <div className="content">
		
		
		<div  style={{display:'none'}}>
<p>business name: {businessName} </p>
<p>business type: {businessType} </p>
<p>business address: {businessAddress} </p>
<p>business email: {businessEmail} </p>
<p>business phone: {businessPhone} </p>
<p>service: {JSON.stringify(services)} </p>
<p>images: {JSON.stringify(images)} </p> 
		</div>
		

  
 
     <div key={step} className="fade">
         
		  
		  <h2  style={{
			marginTop:'30px',



color:'black',
       
		
	  fontSize: '26px',
	  fontWeight: '800',
	  letterSpacing: '-1px',
	  textDecoration: 'none',			
		  }}>
		  
		  {t("credit-code.your_credit_code")}
		  </h2>
     
	 
	 
	 
	 {creditCodeList.length==0 ? (
	 
			<div   style={{
		//background:'white',
        	width:'90vw',
			justifyContent:'center',
			alignItems:'center',
			display:'flex',	
			flexDirection:'column',
		}}>
		
		
		{websiteLoadState =='loaded' ? (
		
		
		<div   style={{
			marginTop:'5vh',
		}}>
		
		<div  style={{
			width:'150px',
			height:'150px',
			borderRadius:'100px',
			//backgroundColor:'white',
			margin:'auto',
		}}>
		
		
		<i   style={{
			width:'150px',
			margin:'auto',
			fontSize:'120px',
			color:'red',
			
		}}
		class="bi bi-gift"></i>
		</div>
		
		<h3  style={{
		color:'purple',
        fontWeight:'bold',
		textAlign:'center',
		}}>
		
		
		{t("credit-code.no_credit_found")}
		</h3>
		
		<p  style={{
			color:'gray',
			fontSize:'15px',
			textAlign:'center',
		}}>
		
		{t("credit-code.check_again")}
		</p>
		
		
		
		<button type="button" onClick={getAllCreditCode} class="btn btn-secondary btn-sm"  style={{margin:'auto'}}>
  {t("credit-code.try_again")}
</button>
		</div>
		):(
		
		
		<div  style={{
		marginTop:'25vh',
		}}>
		<div class="spinner-border" role="status"  
		style={{
		width:'3rem',
		height:'3rem',
		color:'red',
		}}>
   
</div>
 <p>loading...</p>
		</div>
		)}
		
		</div>
	 
	 ):(
	
	<div className="block-list-container" style={{
	marginTop:'20px',
	marginLeft:'-5px',
	
	//background:'white',
	display:'flex',
	flexWrap:'wrap',
    width:'100%',	
	}}>
	
	

		  
	
	 {creditCodeList.map((gift, index) => (
		 
<div className="website-block"  style={{
      
	}}>
	
	

	
	 <div  className="website-block-action">
	 <p  class="title-website">
	 {t("credit-code.status")}: <span style={{
		color:'white',
		//background:'green',
		background: gift.status=='active' ? 'green' : 'red',
		padding:'10px',
		borderRadius:'10px'
		}}>
	
		{gift.status=='active' ? t("credit-code.active") : t("credit-code.expired")}
		</span> 
	 </p>
	 
	 <p  class="title-website">
	 {t("credit-code.for")}: {firebaseUserInfo.displayName} 
	 </p> 
	 
	 
	  <p  class="title-website">
	 {t("credit-code.email")} : {gift.beneficiary_email} 
	 </p> 
	
	 <h1  style={{color:'white',marginLeft:'10px'}}>
		 {gift.credit_code}
	 
	 <button 
	  onClick={() => copyCode(gift.credit_code)}
	// onClick={copyCode} 
	 style={{
	   background:'transparent',
	   boxShadow:'0px 0px 0px',
	   border:'0px solid red',
	 }}>
	 <i class="bi bi-copy"  style={{color:'red',fontWeight:'bold'}}></i>
	 </button>
	 </h1>
	 </div>
    </div>	
	 ))} 
		
		
 
		  

		  

	 </div> 
	  
 )}
	  

	  
	  
		  </div>
		  
      <div   style={{
		 color:'red',
         display:showInputReply,		 
	  }}>
	  {inputReply}
	  </div>
	 
       
		 
          
       
           
      
		
	</div>
	
		
		 
  
 
   
		  
    
	
<ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"

/>
     
    


      </div> 
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	


<div ref={modalRef} class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add a new service</h5>
        <button type="button" class="btn-close" onClick={closeModal} onC data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <input type="text" className="input-box" 
		  placeholder="Service name"
         
value={selectedServiceName}
 onChange={(e) => 
   setSelectedServiceName(e.target.value)
 }		 
		  />
		  <br/>
		  
		  <textarea placeholder="Service description here ...." className="input-box"   style={{
			  borderRadius:"10px",
			  height:"100px",
		  }}
		  
		  value={selectedServiceDescription}
 onChange={(e) => 
   setSelectedServiceDescription(e.target.value)
 }		 
		  
		  >
		  
		  </textarea>
      </div>
      <div class="modal-footer">
	   <button type="button" onClick={addNewService} class="btn btn-primary"  style={{background:'green'}}>Save changes</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"  onClick={closeModal}>Close</button>
       
      </div>
    </div>
  </div>
</div> 
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	   
	  
	  
	  </>
  );
}